import React, {useEffect} from 'react';
import {useFormik} from "formik";
import {requestApi, showAlertAutoDis} from "../../utils/utils";
import PrimaryButton from "../../components/Common/PrimaryButton";
import {useHistory, useParams} from "react-router-dom";

const ChangePasswordPage = () => {
    const {token} = useParams();
    const history = useHistory()

    useEffect(() => {
        if (!token) return history.push('/');
        validateToken().catch();
    }, []);

    const validateToken = async () => {
        const {data: response} = await requestApi('/customer/password/valid-token', 'POST', {token});
        if (response.status === 'success') return;

        showAlertAutoDis({
            title: 'Error',
            text: 'Token is invalid or expired, please generate a new reset link.',
            manualClose: true,
        }, () => {
            return history.push('/booking/forgot_password')
        });

    };

    const formik = useFormik({
        initialValues: {
            password: '',
            passwordConfirm: ''
        },
        onSubmit: async (values) => {
            try {
                if (values.password !== values.passwordConfirm)
                    return showAlertAutoDis({title: 'Error', text: 'Passwords do not match.'});

                let params = {
                    password: values.password,
                    password_confirmation: values.password,
                    token
                };
                const {data} = await requestApi('/customer/password/reset', 'POST', params);

                if (data.status === 'success') {
                    showAlertAutoDis({title: 'Success', text: 'Your password has been changed successfully.'}, () => {
                        history.push('/booking/login');
                    });
                } else {
                    if (data.message)
                        showAlertAutoDis({
                            title: 'Error',
                            html: data.message || 'Unable to reset your password. Please try again.'
                        });
                    else
                        showAlertAutoDis({title: 'Error', text: 'Unable to reset your password. Please try again.'});
                }
            } catch (data) {
                const {title, message: text} = data;
                showAlertAutoDis({title: title || 'Error', text: text || 'Unable to reset your password.'});
            }
        },
    });

    return (
        <div className="wrapper" style={{paddingTop: 50}}>
            <div className="auth_pages nautilus-login">
                <h1>Change Password</h1>
                <form onSubmit={formik.handleSubmit}>
                    <div className="login-container">
                        <div className="col-100 text-left">
                            <label htmlFor="password">New Password</label>
                            <input type="password" name="password" onChange={formik.handleChange}
                                   value={formik.values.password} id="password" placeholder="Password"/>
                        </div>
                        <div className="col-100 text-left">
                            <label htmlFor="passwordConfirm">Confirm Password</label>
                            <input type="password" name="passwordConfirm" onChange={formik.handleChange}
                                   value={formik.values.passwordConfirm} id="passwordConfirm" placeholder="Password"/>
                        </div>

                        <div className="spacer"/>

                        <div className="submit">
                            <PrimaryButton type="submit" style={{width: 'auto', padding: '8px 30px'}}>Change
                                Password</PrimaryButton>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ChangePasswordPage;